'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const StickyMobileQuote = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <Link
        href="/contact"
        className="flex items-center justify-center gap-2 bg-red-600 text-white w-full py-4 font-bold text-base tracking-wide hover:bg-red-700 transition-colors shadow-lg"
      >
        <Icon name="ChatBubbleLeftRightIcon" size={20} />
        Request a Quote
      </Link>
    </div>
  );
};

export default StickyMobileQuote;
